var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCheeseburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 3.49992C4.39052 3.49992 4.16667 3.72378 4.16667 3.99992C4.16667 4.27606 4.39052 4.49992 4.66667 4.49992H14C14.2761 4.49992 14.5 4.27606 14.5 3.99992C14.5 3.72378 14.2761 3.49992 14 3.49992H4.66667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 7.49992C4.39052 7.49992 4.16667 7.72378 4.16667 7.99992C4.16667 8.27606 4.39052 8.49992 4.66667 8.49992H14C14.2761 8.49992 14.5 8.27606 14.5 7.99992C14.5 7.72378 14.2761 7.49992 14 7.49992H4.66667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 11.4999C4.39052 11.4999 4.16667 11.7238 4.16667 11.9999C4.16667 12.2761 4.39052 12.4999 4.66667 12.4999H14C14.2761 12.4999 14.5 12.2761 14.5 11.9999C14.5 11.7238 14.2761 11.4999 14 11.4999H4.66667Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 7.99992C3.33333 8.36811 3.03486 8.66659 2.66667 8.66659C2.29848 8.66659 2 8.36811 2 7.99992C2 7.63173 2.29848 7.33325 2.66667 7.33325C3.03486 7.33325 3.33333 7.63173 3.33333 7.99992Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 3.99992C3.33333 4.36811 3.03486 4.66659 2.66667 4.66659C2.29848 4.66659 2 4.36811 2 3.99992C2 3.63173 2.29848 3.33325 2.66667 3.33325C3.03486 3.33325 3.33333 3.63173 3.33333 3.99992Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 11.9999C3.33333 12.3681 3.03486 12.6666 2.66667 12.6666C2.29848 12.6666 2 12.3681 2 11.9999C2 11.6317 2.29848 11.3333 2.66667 11.3333C3.03486 11.3333 3.33333 11.6317 3.33333 11.9999Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCheeseburger);
export default __webpack_public_path__ + "static/media/MenuCheeseburger.d9f7132d7bd281ad64c5dd9c1517dfd1.svg";
export { ForwardRef as ReactComponent };